import ValidService from "../../../service/ValidService";
export default {
  dataForm: {
    guideName: undefined,
    description: undefined,
    destinationUrl: undefined,
    imgData: undefined,
    audios: [],
    translations: [],
    languageCode: undefined,
  },
  validForm: {
    guideName: [
      ValidService.required,
      ValidService.checkLengthStringBlur(50),
      ValidService.checkLengthStringChange(50),
    ],
    description: [
      ValidService.required,
      ValidService.checkLengthStringBlur(2000),
      ValidService.checkLengthStringChange(2000),
    ],
    destinationUrl: [
      ValidService.required,
      ValidService.checkLinkRequiredProtocol,
    ],
    imgData: [ValidService.required],
    audios: [ValidService.required],
    languageCode: [ValidService.requiredChange],
  },
  tableRules: {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["", "descending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
      value: {
        guideCode: undefined,
        keyword: undefined,
      },
      operator: {
        guideCode: "",
        keyword: "",
      },
    },
  },
};
